export default __webpack_public_path__ + "static/media/clube-img4.8d7296b8.jpg";